const styles = (theme) => ({
  root: {
    color: theme.palette.primary.dark,
    fontSize: '1.125rem',
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  downloadIcon: {
    fontSize: '1.6rem',
    paddingRight: theme.spacing.unit,
  },
});

export default styles;
